import React, { useEffect } from 'react';
import { 
  RefreshCw, 
  ArrowDownUp, 
  Settings, 
  HelpCircle, 
  MessageSquare, 
  Heart, 
  Users
} from 'lucide-react';
import { useNavigate } from "react-router-dom";
const KappelaApp = () => {

  const navigate = useNavigate();
  // Télégram est désactivé pour éviter les erreurs
  /* L'initialisation du WebApp Telegram est désactivée */

  return (
    <div className="max-w-md mx-auto bg-[#BBA4ED] min-h-screen pt-2">
      {/* Balance Card */}
      <div className="mx-4 mb-6">
        <div className="bg-white rounded-3xl p-6 shadow-sm">
          <div className="flex flex-col items-center mb-4">
            <span className="text-gray-600 font-medium mb-2">Balance Disponible</span>
            <div className="text-4xl font-bold text-gray-800 mb-1">320.000</div>
            <span className="text-gray-500">F CFA</span>
          </div>
          
          <div className="grid grid-cols-2 gap-4 mt-4">
            <button  
  onClick={() => {
    //  setTheme(theme === "light" ? "dark" : "light")


    navigate("/soni");
    }

  } className="bg-[#2D4B9A] text-white p-4 rounded-2xl flex items-center justify-center gap-2 h-12 hover:bg-[#243c7a] transition-all">
              <ArrowDownUp className="w-5 h-5" />
              <span className="font-medium">Retrait</span>
            </button>
            <button className="bg-[#22BDD0] text-white p-4 rounded-2xl flex items-center justify-center gap-2 h-12 hover:bg-[#1ca6b7] transition-all">
              <RefreshCw className="w-5 h-5" />
              <span className="font-medium">Historiques</span>
            </button>
          </div>
        </div>
      </div>

      {/* Actions Section */}
      <div className="px-4 pt-4 pb-8 bg-white rounded-t-3xl shadow-lg">
        <h2 className="text-gray-800 text-lg font-bold mb-4">Actions Rapides</h2>
        <div className="grid grid-cols-3 gap-4 mb-8">
          <ActionButton 
            icon={<Heart className="w-6 h-6 text-pink-500" />}
            label="Donation"
            navigate={navigate}
          />
          <ActionButton 
             

            

            icon={<MessageSquare className="w-6 h-6 text-blue-500" />}
            label="Produits"
          />
          <ActionButton 
        
            icon={<Users className="w-6 h-6 text-green-500" />}
            label="Groupes"
          />
          <ActionButton 
            icon={<Settings className="w-6 h-6 text-gray-600" />}
            label="Paramètres"
          />
          <ActionButton 
            icon={<HelpCircle className="w-6 h-6 text-cyan-500" />}
            label="FAQ"
          />
          <ActionButton 
            icon={<MessageSquare className="w-6 h-6 text-purple-500" />}
            label="Support"
          />
        </div>

        {/* Offers Section */}
        <div>
          <h2 className="text-xl font-bold text-gray-800 mb-4">Offres Premium</h2>
          <div className="overflow-x-auto scrollbar-hide">
            <div className="flex gap-4 pb-4">
              <OfferCard 
                title="Accès VIP"
                features={["Alertes en temps réel", "Signaux privés", "Analyses"]}
                duration="Mensuel"
                color="bg-[#2D4B9A]"
              />
              <OfferCard 
                title="Communauté Pro"
                features={["Brainstorming", "Sessions Q&A", "Networking"]}
                duration="Hebdomadaire"
                color="bg-[#9D82CC]"
              />
              <OfferCard 
                title="Premium Plus"
                features={["Coaching VIP", "Support 24/7", "Accès total"]}
                duration="Trimestriel"
                color="bg-[#22BDD0]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ icon, label,navigate }) => (
  
  <button 

  onClick={() => {
    //  setTheme(theme === "light" ? "dark" : "light")


    navigate("/relierbot");
    }

  }
  
  
  className="flex flex-col items-center justify-center p-3 bg-gray-50 rounded-2xl hover:bg-gray-100 transition-all">
    <div className="p-2 bg-white rounded-xl shadow-sm mb-1">{icon}</div>
    <span className="text-xs font-medium text-gray-600">{label}</span>
  </button>
);

const OfferCard = ({ title, features, duration, color }) => (
  <div className={`${color} p-6 rounded-2xl w-72 shrink-0`}>
    <h3 className="font-bold text-lg text-white mb-4">{title}</h3>
    <ul className="space-y-2 mb-4">
      {features.map((feature, index) => (
        <li key={index} className="flex items-center gap-2 text-sm text-white">
          • {feature}
        </li>
      ))}
    </ul>
    <div className="flex justify-between items-center">
      <p className="text-sm text-white/90">{duration}</p>
      <button className="bg-white/20 px-4 py-2 rounded-xl text-white text-sm hover:bg-white/30 transition-all">
        Détails
      </button>
    </div>
  </div>
);

export default KappelaApp;